import styled from 'styled-components';
import { getTranslatedText, DeleteModal } from '@nile/components';
import React from 'react';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

/**
 * Cells are specific to the components using the table.
 * This action cell is used to delete a specific item in the table.
 */

const allow = () => {
  return true;
};

function ActionCell(props) {
  const { cell, intl } = props;
  const meta = cell?.row?.original;
  const { actions, labels, variant, sectioned } = cell.column;
  const checkDeleteOperation = actions?.checkDeleteItemAllowPermission || allow;
  const modalActivator = (
    <div className="ml8 deleteItem ptr">
      <div id={`delete-list-item${cell?.row?.id ? `-${cell.row.id}` : ''}`}>
        <SVGIcon name="Delete" />
      </div>
    </div>
  );
  return (
    checkDeleteOperation(meta) && (
      <DeleteModal
        modalActivator={modalActivator}
        description={getTranslatedText(
          intl,
          labels?.description ||
            'admin.serviceCatalog.list.deleteItem.modalDescription'
        )}
        handleDeleteConfirmation={() => actions.onClick(meta)}
        title={getTranslatedText(
          intl,
          labels?.title || 'admin.serviceCatalog.list.deleteItem.title'
        )}
        sectioned={sectioned}
        variant={variant}
      />
    )
  );
}

export default injectIntl(ActionCell);
